import storage from "store";
import store from "@/store";
import { whiteList } from "./basics.router";
import { Router, RouteRecordRaw } from "vue-router";
import useGlobalEventBus from "@/hooks/useGlobalEventBus";
import { AppCollection, F2EHB_APP_ROUTE, F2EHB_NAME } from "@/constant";
export const loginPath = "/login";
const EventBus = useGlobalEventBus();
const defultPath = F2EHB_APP_ROUTE.path;

// 权限验证
export const permission = (router: Router) => {
  router.beforeEach((to, from, next) => {
    if (storage.get("token")) {
      // 有token，解析to
      if (to.path === loginPath) {
        // 无需登录，去默认页或指定的路由
        const query = to.query || {};
        const { target, from, app, ...rest } = query;
        if (from && from === "F2E" && target) {
          EventBus.$registerMountedQueue(
            app as AppCollection,
            "CHANGE_ROUTE",
            {
              path: target,
              query: { ...rest },
              app: app || F2EHB_NAME,
            },
            store
          );
          next();
        } else {
          next({ path: defultPath });
        }
      } else {
        if (store.state.user.nick.length === 0) {
          // 二次判断一下是否有用户信息
          store
            .dispatch("user/userInfo")
            .then(() => {
              store.dispatch("user/menu").then((e) => {
                e.forEach((item: RouteRecordRaw) => {
                  router.addRoute(item);
                });
                router.addRoute({ path: "/:pathMatch(.*)*", redirect: "/404" });
                const redirect = from.query.redirect as string | undefined;
                if (redirect && to.fullPath === redirect) {
                  next({ ...to, replace: true });
                } else {
                  next({ ...to });
                }
              });
            })
            .catch(() => {
              storage.remove("token");
              next({ path: loginPath, query: { redirect: to.fullPath } });
            });
        } else {
          next();
        }
      }
    } else {
      // 没有token，判断是否在白名单、是否跳登录
      if (whiteList.includes(to.path)) {
        next();
      } else {
        store.dispatch("user/clearState");
        next({ path: loginPath, query: { redirect: to.fullPath } });
      }
    }
  });
};
